import React from 'react';

const VerifyData: React.FC = () => {
  return (
    <div>
      <h1>VerifyData Page</h1>
      <p>This is the VerifyData Page.</p>
    </div>
  );
};

export default VerifyData;
